export default __webpack_public_path__ + "static/media/woodman_thumb.d9b899ea.jpg";